import { ScreenOptions } from '../../../shared/pages/interfaces/ScreenOptions';
import { ViewColumnSystemName } from '../../../../../shared/entities/view/components/view-grid/enums/ViewColumnSystemName';
import { ViewOptionsService } from '../../../../../shared/entities/view/components/view/services/ViewOptionsService';
import { screensInvestorsSharedOptions } from './screensInvestorsSharedOptions';
import { ViewFilterName } from '../../../../../shared/entities/filters/enum/types/ViewFilterName';

export const screensInvestorsLandingOptions: Partial<ScreenOptions> = ViewOptionsService.merge<ScreenOptions>(
  screensInvestorsSharedOptions,
  {
    grid: {
      title: 'ALL INVESTORS ACTIVITY',
      idCols: [ViewColumnSystemName.InvestorKey],
    },
    screenTriggerOptions: {
      columnName: ViewColumnSystemName.Investor,
      filterName: ViewFilterName.Investor,
      filterValueColumnName: ViewColumnSystemName.InvestorKey,
    },
  },
);
